import { styled } from '@mui/material';
import Button from '../../../../../components/Button';
import { buttonClasses } from '../../../../../components/Button/styles';
import { hexToRgba } from '../../../../../utils/color';

export const RetakeAttendanceButton = styled(Button)(({ theme }) => ({
  textTransform: 'uppercase',
  backgroundColor: theme.palette.success[400],
  borderRadius: `0 0 ${theme.spacing(4)} ${theme.spacing(4)}`,

  '&:hover': {
    backgroundColor: theme.palette.success[500],
  },

  [`&.${buttonClasses.disabled}`]: {
    color: hexToRgba(theme.palette.success[400], 1),
    backgroundColor: hexToRgba(theme.palette.success[400], 0.2),
    opacity: 1,
  },
}));
